import { EventLogTypeGQLType } from 'types/dashboard-core-gqlTypes.generated';

export const basicStringSearch = (
  searchString: string,
  compareString: string,
) => {
  const search = searchString.toLocaleLowerCase().trim();
  const compare = compareString.toLocaleLowerCase();
  return compare.includes(search);
};

export const eventLogTypeToDomain = (eventTypes: EventLogTypeGQLType[]) => [
  ...new Set(
    eventTypes
      .map((type) => type.split('_').at(0))
      .filter((entityType) => typeof entityType === 'string'),
  ),
];
